<template>

  <div
    class="action-bar d-flex flex-row action-bar-small action-bar-default-position"
    :class="classList"
  >
    <div
      class="close-container"
      @click="emitClose"
    >
      <img
        class="icon-close"
        alt="icon-close"
        :src="require('@/assets/img/icons/close-menu.svg')"
      />
    </div>
    <div class="action-bar-container d-flex flex-row justify-content-between align-items-center w-100">
      <div class="action-labels h-100  d-flex align-items-center">
        <slot name="selectedItems"></slot>
      </div>

      <div class="actions-container d-flex align-items-center justify-content-evenly ml-3">
        <slot name="actions">
        </slot>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'MultipleActionsBanner',
  props: {
    classList: {
      type: String,
      default: ''
    }
  },
  methods: {
    emitClose () {
      this.$emit('closeBar')
      this.$store.dispatch('TransactionsStore/clearSelectedTransactions')
    }
  },
  computed: {
    isSideBarMenuOpen () {
      return this.$store.getters['GlobalStore/sideMenuIsOpen']
    }
  }
}
</script>

<style lang="scss" scoped>
.action-bar {
  position: fixed;
  align-items: center;
  left: 50%;
  right: 50%;
  bottom: 0%;
  transform: translate(-50%, -50%);
  width: fit-content;
  min-width: 570px;
  padding: 0 16px;
  height: 48px;
  background-color: white;
  border: 1px solid var(--fill-background);
  border-radius: 3px;
  z-index: 1;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.close-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  width: 16px;
  height: 16px;
  &:hover {
    background-color: var(--grey-action-3-hover);
  }
  img {
    width: 8px;
    height: 8px;
  }
}

@media screen and (max-width: 576px) {
  .action-bar {
    display: flex;
    min-width: 300px;
    flex-direction: column !important;
    justify-content: space-around !important;
    min-height: 35vh;
    width: calc(100% - 30px);
    padding-right: 0px;
    top: 80vh;
  }
  .action-bar-container {
    display: flex;
    flex-direction: column !important;
    justify-content: center !important;
  }
  .actions-container > * {
    flex-direction: column;
    max-width: 300px;
  }
  .action-labels {
    width: 100%;
    margin: 20px 0px;
    justify-content: flex-start !important;
    flex-direction: column;
  }
  .actions-container button {
    margin: 10px 0px;
    width: 100%;
    text-align: center;
  }
  .close-container {
    margin: 5px 45%;
  }
  .icon-close {
    width: 13px;
    height: 13px;
  }
}
</style>
